import { ANYONE_ID } from 'Calendar/anyone';
import { ICalendarItemData } from 'Calendar/types';
import moment from 'utils/moment';
import { IAppointmentItemData } from 'types/appointment';
import { IAppointmentResItem } from './types/response';

const doubleCheckFormat = (value: string) => {
  if (value.endsWith('AM') || value.endsWith('PM')) {
    return 'MM/DD/YYYY HH:mm A';
  }
  return 'HH:mm A MM-DD-YYYY';
};

export const mappingResToCalendarDataItem = (o: IAppointmentResItem) => {
  const startTime = moment(o.start_time, doubleCheckFormat(o.start_time));
  let endTime = moment(o.end_time, doubleCheckFormat(o.end_time));
  if (o.start_time === o.end_time) {
    endTime = startTime.clone().add(15, 'minute');
  }

  return ({
    id: o.id?.toString(),
    type: 'apt',
    data: {
      id: o.id?.toString(),
      customerId: o.customerId?.toString() || '0',
      customerName: o.customerName,
      customerPhone: o.customerPhone,
      services: o.services.map(s => ({
        duration: s.duration,
        serviceId: s.id.toString(),
        serviceName: s.serviceName,
      })),
      sourceType: o.bookingType,
      staffId: o.staffId?.toString() || '0',
      startTime: startTime.format('MM-DD-YYYY HH:mm:ss'),
      endTime: endTime.format('MM-DD-YYYY HH:mm:ss'),
      note: o.note || '',
      status: o.status,
      isAnybody: !!o.isAnybody,
      requestStaff: o.requestStaff ?? false,
      confirmed: o.strStatus === 'CONFIRMED' || o.strStatus === 'CHECK_IN',
    } as IAppointmentItemData,
    staffId: (!o.staffId || o.staffId === 0) ? ANYONE_ID : o.staffId.toString(),
    startTime: startTime.format('MM-DD-YYYY HH:mm:ss'),
    endTime: endTime.format('MM-DD-YYYY HH:mm:ss'),
  }) as ICalendarItemData;
};

